export const PERMISSIONS = {
  AC_OTHERACCVOUCHER_ADD: 'AC_OTHERACCVOUCHER_ADD',
  AC_OTHERACCVOUCHER_DEL: 'AC_OTHERACCVOUCHER_DEL',
  AC_OTHERACCVOUCHER_EDIT: 'AC_OTHERACCVOUCHER_EDIT',
  AC_OTHERACCVOUCHER_VIEW: 'AC_OTHERACCVOUCHER_VIEW',
  AC_OTHERACCVOUCHER_PRINT: 'AC_OTHERACCVOUCHER_PRINT',
  AC_OTHERACCVOUCHER_EXPORT: 'AC_OTHERACCVOUCHER_EXPORT',
};
